export default {
  methods: {
    handleDescriptionChange (payload) {
      this.description = payload
    }
  }
}
